export class Variables {
    pass = '#ranitessarldev2020';
}
